import { InventoryMeterMountType } from '@enmon/commons/lib/tools/api/inventory-meter';
import { INVENTORIZATION_PHOTO_SLOT_IDS, type PhotoSlotDefinition } from '@/shared/capture/inventorization-photo-slots';
import { translateInventoryText } from '@/shared/i18n/inventory-i18n';

const photoSlotKeyById: Record<string, string> = {
  [INVENTORIZATION_PHOTO_SLOT_IDS.context]: 'context',
  [INVENTORIZATION_PHOTO_SLOT_IDS.detail]: 'detail',
  [INVENTORIZATION_PHOTO_SLOT_IDS.module]: 'module',
  [INVENTORIZATION_PHOTO_SLOT_IDS.registerMain]: 'registerMain',
};

const mountTypeKeyByValue: Record<string, string> = {
  [InventoryMeterMountType.Free]: 'free',
  [InventoryMeterMountType.MountedFree]: 'mountedFree',
  [InventoryMeterMountType.MountedOccupied]: 'mountedOccupied',
};

export function photoWizardText(key: string, fallback: string, values?: Record<string, string | number>) {
  return translateInventoryText(`app.inventory.photoWizard.${key}`, fallback, values);
}

export function photoWizardSlotLabel(slot: PhotoSlotDefinition) {
  const slotKey = photoSlotKeyById[slot.id];

  return slotKey ? photoWizardText(`slots.${slotKey}.label`, slot.label) : slot.label;
}

export function photoWizardMountTypeLabel(value: string, fallback: string) {
  const optionKey = mountTypeKeyByValue[value];

  return optionKey ? photoWizardText(`mountType.${optionKey}.label`, fallback) : fallback;
}

export function photoWizardMountTypeDescription(value: string, fallback: string) {
  const optionKey = mountTypeKeyByValue[value];

  return optionKey ? photoWizardText(`mountType.${optionKey}.description`, fallback) : fallback;
}
